import React, { useState, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addSystemExperienceAction,
    updateSystemExperienceAction,
    deleteSystemExperienceAction
} from '../../../redux/actions/admin/adminAction';
import Select from "react-select";
import { groupdata } from '../helper/index'

export const System = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'system_experience': '', 'system': '', 'score': '' })
    const [show, setShow] = useState(false);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            top: "5px",
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "#309CCA" : "#309CCA",
        }),
    };

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'system_experience': '', 'system': '', 'score': '' })
        setShow(false)
    };

    const handleSeclect = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            ['system']: event.id
        }))
    }


    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateSystem(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addSystem(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteSystem(id)
    }
    const [SystemsColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "System", field: 'system_experience', filter: true, },
        { headerName: "Types of System", field: 'system_name', filter: true, },
        { headerName: "Score", field: 'score', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={groupdata(props.system, props.systemExpereine, 'system', 'system_name')}
                defaultColDef={defaultColDef}
                columnDefs={SystemsColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Systems</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <h3>system</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="system_experience"
                                name="system_experience"
                                value={inputData.system_experience}
                                onChange={handleChange}
                                placeholder="System"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Type of System</h3>
                        <div className="">
                            <Select
                                id="system"
                                name="system"
                                options={props.system}
                                value={inputData.system ?
                                    props.system.find(
                                        (row) =>
                                            row.id === inputData.system) :
                                    null
                                }
                                getOptionLabel={(option) => option.system}
                                getOptionValue={(option) => option.id}
                                onChange={(event) => handleSeclect(event)}
                                placeholder="Choose.."
                                isClearable={true}
                                styles={customStyles}

                            />
                        </div>
                        <br></br>
                        <h3>Score</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="score"
                                name="score"
                                value={inputData.score}
                                onChange={handleChange}
                                placeholder="Score"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const system = state.admin.system;
    const systemExpereine = state.admin.systemExpereine;

    return {
        system: system,
        systemExpereine: systemExpereine,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addSystem: (data) => dispatch(addSystemExperienceAction(data)),
        updateSystem: (id, data) => dispatch(updateSystemExperienceAction(id, data)),
        deleteSystem: (id) => dispatch(deleteSystemExperienceAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(System)

